import React from 'react';
import { Chip, type ChipProps } from '@mui/material';
import { LAYOUT_MAIN_SCROLL_ID } from './BackToTopFab';

/** Stop the delete icon taking focus so unmounting a chip does not jump the page. */
export const keepMainScrollOnChipDeleteIcon = {
  onMouseDown: (event: React.MouseEvent) => {
    event.preventDefault();
  },
};

export const restoreMainScrollSoon = (scrollTop: number) => {
  const restore = () => {
    const pane = document.getElementById(LAYOUT_MAIN_SCROLL_ID);
    if (pane) pane.scrollTop = scrollTop;
  };
  restore();
  if (typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(restore);
  }
};

const isChipDeleteIconEvent = (event: React.MouseEvent) => {
  const target = event.target;
  return target instanceof Element && Boolean(target.closest('.MuiChip-deleteIcon'));
};

/** Dismissible filter tag that keeps the main pane’s scroll position. */
export const HouseholdFilterChip: React.FC<ChipProps> = ({ onDelete, onMouseDown, ...props }) => (
  <Chip
    {...props}
    onMouseDown={(event) => {
      if (isChipDeleteIconEvent(event)) {
        keepMainScrollOnChipDeleteIcon.onMouseDown(event);
      }
      onMouseDown?.(event);
    }}
    onDelete={
      onDelete
        ? (event) => {
            const pane = document.getElementById(LAYOUT_MAIN_SCROLL_ID);
            const top = pane?.scrollTop ?? 0;
            onDelete(event);
            restoreMainScrollSoon(top);
          }
        : undefined
    }
  />
);
